import React, { Component } from 'react';

import ComprobanteDownloadActions from './ComprobanteDownloadActions';

class SingleComprobanteActions extends Component {
  state = {
    showConfirm: false,
  };

  handleOnCancelRequest = () => {
    this.setState({
      showConfirm: true,
    });
  };

  render() {
    const { data } = this.props;

    return (
      <div className="d-inline-block mr-2">
        <ComprobanteDownloadActions data={data} />
      </div>
    );
  }
}

export default SingleComprobanteActions;
